<template>
  <hm-content title="" :hidden="hidden">
    <div class="table-panel flex flex-end text-right">
      <el-input
        size="small"
        clearable
        class="mr10 ipt"
        v-model.trim="searchCondition.receiptSn"
        placeholder="请输入订单号"
      ></el-input>
      <!-- <el-cascader
        v-model="searchCondition.wxshopCategoryId"
        :show-all-levels="false"
        size="small"
        class="mr10"
        :props="categoryFunc"
        clearable
        placeholder="请选择微店商品分类"
      ></el-cascader> -->
      <el-input
        size="small"
        clearable
        class="mr10 ipt"
        v-model.trim="searchCondition.goodsSn"
        placeholder="请输入商品货号"
      ></el-input>
      <el-date-picker
        v-model="searchCondition.date"
        type="datetimerange"
        align="right"
        start-placeholder="请选择下单时间段"
        end-placeholder="请选择下单时间段"
        value-format="yyyy-MM-dd HH:mm:ss"
        :default-time="['00:00:00', '23:59:59']"
        size="small"
        class=" mr10"
      ></el-date-picker>
      <el-input
        size="small"
        clearable
        class="mr10 ipt"
        v-model.trim="searchCondition.receiverMobile"
        placeholder="请输入收货人手机"
      ></el-input>
      <el-input
        size="small"
        clearable
        class="mr10 ipt"
        v-model.trim="searchCondition.memberMobile"
        placeholder="请输入会员手机"
      ></el-input>
      <el-input
        size="small"
        clearable
        class="mr10 ipt"
        v-model.trim="searchCondition.referMemberMobile"
        placeholder="请输入推荐人手机"
      ></el-input>
      <el-input
        size="small"
        clearable
        class="mr10 ipt"
        v-model.trim="searchCondition.belongDepotName"
        placeholder="请输入仓库名称"
      ></el-input>
      <el-button type="primary" size="small" @click="search">查询</el-button>
      <el-button type="info" size="small" @click="searchCondition = {}"
        >重置</el-button
      >
    </div>
    <!-- <div class="table-panel flex flex-start"></div> -->
    <div class="flex flex-start table-panel ">
      <el-button type="primary" size="small" @click="reports"
        >生成报表</el-button
      >
    </div>
    <div class="table">
      <el-table
        stripe
        border
        ref="table"
        :data="list"
        style="width: 100%"
        id="table"
        size="small"
        height="600"
      >
        <el-table-column
          type="index"
          label="序号"
          header-align="center"
          align="center"
          :index="index => index + (currentPage - 1) * pageSize + 1"
        ></el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiptSn"
          label="订单号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="oneCategoryName"
          label="一级分类名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="twoCategoryName"
          label="二级分类名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="threeCategoryName"
          label="三级分类名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="brandName"
          label="品牌名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="spuName"
          width="200"
          show-overflow-tooltip
          label="商品名称"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsSn"
          label="商品货号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="specIdGroupName"
          label="商品规格"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="barCode"
          label="商品条码"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="goodsNum"
          label="商品数量"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="totalPrice"
          label="商品原价"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realPrice"
          label="商品折后单价"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="realTotalPrice"
          label="商品折后总价"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="purchaseTime"
          label="下单时间"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="deliveryType"
          label="配送方式"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiverName"
          label="收货人姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="receiverMobile"
          label="收货人手机"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="deliveryProvince"
          label="收货区域"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="deliveryAddress"
          label="收货人地址"
        >
        </el-table-column>

        <el-table-column
          header-align="center"
          align="center"
          prop="memberMobile"
          label="会员手机"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="payMode"
          label="支付状态"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="orderState"
          label="订单状态"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="actuallyPrice"
          label="订单总价实付金额"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="referId"
          label="推荐人id"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="referMemberMobile"
          label="推荐人手机号"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="referMemberName"
          label="推荐人姓名"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="referDepartName"
          label="推荐人所属机构"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="belongShopName"
          label="订单指定门店"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="belongDepotName"
          label="所属仓库名（POS里的仓库）"
        >
        </el-table-column>
        <el-table-column
          header-align="center"
          align="center"
          prop="returnType"
          label="商品退货进度"
        >
        </el-table-column>
      </el-table>
      <div class="hm-pagination">
        <el-pagination
          background
          :total="total"
          @current-change="paging"
          @size-change="handleSizeChange"
          layout="total, sizes, prev, pager, next, jumper"
          :current-page="currentPage"
          :page-size="pageSize"
        ></el-pagination>
      </div>
    </div>
  </hm-content>
</template>

<script>
import { setCookie, getCookie } from "@/utils/utils";
export default {
  components: {},
  data() {
    return {
      hidden: true,
      total: 0,
      currentPage: 1,
      pageSize: 10,
      list: [],
      categoryFunc: {
        checkStrictly: true,
        lazy: true,
        lazyLoad: (node, resolve) => {
          const { level, data } = node;
          if (level === 0) {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: 1
              })
              .then(res => {
                res.result.forEach(v => {
                  v.value = v.wxshopCategoryId;
                  v.label = v.categoryName;
                });
                resolve(res.result);
              });
          } else {
            this.$store
              .dispatch("queryMicroShopGoodsCategoryTree", {
                categoryLevel: level + 1,
                wxshopParentCategoryId: data.wxshopCategoryId
              })
              .then(res => {
                this.level = level + 1;
                if (res.code === "0" && res.result.length) {
                  res.result.forEach(v => {
                    v.value = v.wxshopCategoryId;
                    v.label = v.categoryName;
                  });
                  resolve(res.result);
                } else {
                  resolve([]);
                }
              });
          }
        }
      },
      searchCondition: {
        date: ""
      }
    };
  },
  computed: {},
  watch: {},
  created() {
    let nowDate = new Date();
    let date = {
      year: nowDate.getFullYear(),
      month: nowDate.getMonth() + 1,
      date: nowDate.getDate()
    };
    if (date.month >= 1 && date.month <= 9) {
      date.month = "0" + date.month;
    }
    if (date.date >= 0 && date.date <= 9) {
      date.date = "0" + date.date;
    }
    let systemDate = date.year + "-" + date.month + "-" + date.date;

    this.searchCondition.date = [
      `${systemDate} 00:00:00`,
      `${systemDate} 23:59:59`
    ];
    this.getParamsCookie();
  },
  mounted() {
    this.queryList();
  },
  methods: {
    setParamsCookie() {
      setCookie({
        key: "onlineOrderBreakdownParams",
        type: "session",
        data: Object.assign({}, this.searchCondition, {
          pageSize: this.pageSize,
          currentPage: this.currentPage
        })
      });
    },
    getParamsCookie() {
      const prams = getCookie({
        key: "onlineOrderBreakdownParams",
        type: "session"
      });
      if (prams) {
        let search = {};
        for (let key in prams) {
          if (key !== "pageSize" && key !== "currentPage") {
            search[key] = prams[key];
          }
        }
        this.searchCondition = search;
        this.pageSize = prams.pageSize;
        this.currentPage = prams.currentPage;
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    async queryList() {
      if (this.isArray(this.searchCondition.date)) {
        let params = {
          pageNo: this.currentPage,
          pageSize: this.pageSize
        };
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.purchaseStartTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[0]
            : "";
        searchCondition.purchaseEndTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[1]
            : "";
        searchCondition.wxshopCategoryId = this.isArray(
          searchCondition.wxshopCategoryId
        )
          ? searchCondition.wxshopCategoryId[
              searchCondition.wxshopCategoryId.length - 1
            ]
          : searchCondition.wxshopCategoryId;
        this.setParamsCookie();
        Object.assign(params, searchCondition);
        const { result } = await this.$store.dispatch(
          "queryDaystatOrderDetailsList",
          params
        );
        const { records, total } = result;
        this.list = records;
        this.total = total;
      } else {
        this.$message({
          message: "请选择查询时间段！",
          type: "warning"
        });
      }
    },
    search() {
      this.currentPage = 1;
      this.queryList();
    },
    async reports() {
      if (this.isArray(this.searchCondition.date)) {
        const searchCondition = JSON.parse(
          JSON.stringify(this.searchCondition)
        );
        searchCondition.purchaseStartTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[0]
            : "";
        searchCondition.purchaseEndTime =
          this.searchCondition.date && this.searchCondition.date.length > 0
            ? this.searchCondition.date[1]
            : "";
        searchCondition.wxshopCategoryId = this.isArray(
          searchCondition.wxshopCategoryId
        )
          ? searchCondition.wxshopCategoryId[
              searchCondition.wxshopCategoryId.length - 1
            ]
          : searchCondition.wxshopCategoryId;

        const { code } = await this.$store.dispatch(
          "queryExportOrderDetails",
          searchCondition
        );
        if (code === "0") {
          this.hidden = false;
          this.$message({
            message: "已加入导出队列，请在导出列队中查看！",
            type: "success"
          });
        }
      } else {
        this.$message({
          message: "请选择查询时间段！",
          type: "warning"
        });
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>
<style lang="scss" scoped>
</style>
